import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProductSelect from '@/components/product/ProductSelect.vue';
import { PropType, ref, watch, onMounted } from 'vue'
import { Term } from '@/types/product';
import useStilesService from '@/services/stiles-service';


export default /*#__PURE__*/_defineComponent({
  __name: 'StileSelect',
  props: {
    modelValue: { type: Object as PropType<Term | null>, required: false },
    width: { type: Object as PropType<Term | null>, required: false },
    series: { type: Object as PropType<Term | null>, required: false },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props





const stileSelection = ref<Term | undefined>()
const stileTerms = ref<Term[]>([])
const disableForm = ref<Boolean>(false)
const stileService = useStilesService()
const storedUserSelection = ref<Term>()

watch(() => [props.width, props.series], async (current, old) => {
    stileTerms.value = await getStileTerms();
})

watch(stileSelection, (current, old) => {
    emits("update:modelValue", current)
})

function trackUserSelection(event: any) {
    storedUserSelection.value = stileTerms.value.find(o => o.id == event.target.value)
}

async function getStileTerms(initialSelection = null) {
    let terms: Term[] = []
    let commercial538: Term | undefined
    disableForm.value = false

    if (props.width) {
        terms = await stileService.getStileTermsByDoorWidth(parseFloat(props.width.name))
    }
    if (props.series?.slug.includes("commercial")) {
        commercial538 = terms.find(o => o.name === '5-3/8')
    }
    if (commercial538) {
        stileSelection.value = commercial538
        disableForm.value = true
    } else if(initialSelection) {
        stileSelection.value = initialSelection
    } else {
        stileSelection.value = terms.find(o => o.name == storedUserSelection.value?.name) || terms[0]
    }

    return terms
}

onMounted(async () => {
    stileTerms.value = await getStileTerms(props.modelValue)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ProductSelect, {
    modelValue: stileSelection.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stileSelection).value = $event)),
    name: "stiles",
    label: "Stiles",
    terms: stileTerms.value,
    "disable-form": disableForm.value.valueOf(),
    onChange: trackUserSelection
  }, null, 8, ["modelValue", "terms", "disable-form"]))
}
}

})